import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import { useStore } from '../../lib/context'

import { observer } from 'mobx-react-lite'
import { motion } from 'framer-motion'
import css from 'styled-jsx/css'

import { Carrot } from './'

const DirectoryDropdown = observer(() => {
	const {
		uiStore: {
			updateMapActiveFilterMobile,
			map__activeFilterMobile,
			updateNavBarTextColor,
			directory__mobileMenuOpen,
			toggleMobileDirectoryMenu,
		},
	} = useStore()

	const setBusinessActive = () => {
		updateMapActiveFilterMobile('Business')
		window.history.pushState('Business', 'Business', '/bloomseason/business/')
	}

	const animateBusiness = {
		y:
			map__activeFilterMobile === 'Business'
				? 0
				: 'var(--nav-bar-height-mobile)',
		opacity: map__activeFilterMobile === 'Business' ? 1 : 0.4,
	}

	const setBeingActive = () => {
		updateMapActiveFilterMobile('Being')
		window.history.pushState('Being', 'Being', '/bloomseason/being/')
	}

	const animateBeing = {
		y:
			map__activeFilterMobile === 'Business'
				? 0
				: 'calc(-1*var(--nav-bar-height-mobile))',
		opacity: map__activeFilterMobile === 'Business' ? 0.4 : 1,
	}

	return (
		<>
			<div onClick={toggleMobileDirectoryMenu} className="links">
				<motion.div animate={animateBusiness}>
					<div className="link" onClick={() => setBusinessActive()}>
						Business
					</div>
				</motion.div>
				<motion.div animate={animateBeing}>
					<div className="link" onClick={() => setBeingActive()}>
						Being
					</div>
				</motion.div>
				<Link to={'/beyond/'}>
					<div className="link" style={{ opacity: 0.4 }}>
						Beyond
					</div>
				</Link>
				<Link to={'/community/'}>
					<div className="link" style={{ opacity: 0.4 }}>
						Community
					</div>
				</Link>
			</div>

			<Carrot />

			<style jsx>{`
				@media only screen and (max-width: 768px), (pointer: coarse) {
					.links {
						display: flex;
						flex-direction: column;
					}
					.link {
						font-family: 'Elizeth';
						font-weight: 500;
						color: black;
						text-transform: uppercase;
						padding-right: 0.625rem;
						font-size: var(--font--xs);
						height: var(--nav-bar-height-mobile);
						display: flex;
						justify-content: flex-end;
						align-items: center;
						cursor: pointer;
					}
				}
			`}</style>
		</>
	)
})

export default DirectoryDropdown
